import CarouselCategorySection from "component/design-system/category-selection/CarouselCategorySection";
import HorizontalSeparator from "component/design-system/horizontal-separator/HorizontalSeparator";
import withErrorHandler from "component/design-system/withErrorHandler";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useSelector } from "react-redux";
import { validateVehicle } from "util/vehicle/validate-vehicle";

function MakeModelTierLinks(props: any) {
  const { tier2MakeModels = [], tier3MakeModels = [] } = props;

  const selectedVehicle = useSelector((state: RootState) => state.garage.selectedVehicle);
  const { t } = useTranslation("product");

  if (validateVehicle(selectedVehicle)) {
    return null;
  }

  return (
    <>
      <CarouselCategorySection
        {...{
          categoryUrls: [...tier2MakeModels, ...tier3MakeModels]
            .slice(0, 30),
          maxRows: 3,
          title: t("browse_similar_products"),
        }}
      />
      <HorizontalSeparator className="m-b-20 m-t-30" />
    </>
  );
}

export default withErrorHandler(MakeModelTierLinks);
